/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var bluetoothlist = "";
  var bluetoothlistcounterfeit = "";
  var paperlist = "";
  var paperSize = [57, 80];
  var checked = "";
  var checkedcountereit = "";
  var version = "(NOT AVAILABLE)";
  var user = localStorage.getItem("username");
  var uuid = "";
  var currentVersion = window.version; // Check if printer has been set or not

  if (localStorage.getItem("paperSize") == "" || localStorage.getItem("paperSize") == undefined || localStorage.getItem("paperSize") == null) localStorage.setItem("paperSize", 0);

  var logout = function logout() {
    $f7.request({
      method: 'get',
      url: window.waypoint + 'logout.aspx',
      data: {
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);

        if (data.status == "1") {
          console.log("logout");
          localStorage.setItem("username", "");
          localStorage.setItem("password", "");
          localStorage.setItem("nickname", "");
          window.staffname = undefined;
          window.staffid = undefined;
          $f7.tab.show("#view-home", true);
          if (window.service == "agent") $f7.views.main.router.navigate("/agent_home/", {
            reloadCurrent: true,
            force: true
          });
          if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/", {
            reloadCurrent: true,
            force: true
          });
          if (window.service == "kiosk") $f7.views.main.router.navigate("/kiosk_home/", {
            reloadCurrent: true,
            force: true
          });
        } else {
          $f7.dialog.alert("Unable to logout");
        }
      }
    });
  };

  $update();
  $(document).on('click', '.paperSize', function (e) {
    if (window.service = "agent") {
      if (window.agentType == "AG") {
        localStorage.setItem("paperSize", $('input[name="paperSize"]:checked').val());
      } else {
        if ($('input[name="paperSize"]:checked').val() == "80") {
          $f7.dialog.alert("This paper type is not compatible with your device");
        } else {
          localStorage.setItem("paperSize", $('input[name="paperSize"]:checked').val());
        }
      }
    } else {
      localStorage.setItem("paperSize", $('input[name="paperSize"]:checked').val());
    }
  });
  $(document).on('click', '.lang', function (e) {
    console.log($('input[name="lang"]:checked').val());
    localStorage.setItem("lang", $('input[name="lang"]:checked').val()); // LANGUAGE CONTROLLER BEGIN

    $(".en").hide();
    $(".cn").hide();
    $(".tl").hide();
    $("." + localStorage.getItem("lang")).show();
    window.lang = localStorage.getItem("lang"); // LANGUAGE CONTROLLER END
  });

  var onSuccess = function onSuccess(data) {
    alert('message: ' + data.message);
  };

  function onError(error) {
    alert('message: ' + error.message);
  }

  var updateSystem = function updateSystem() {
    if ($f7.device.cordova == true) {
      if (window.updateFile != undefined) {
        $f7.dialog.alert("Downloading system update...");
      } else {
        $f7.dialog.alert("Unable to download...");
        return;
      } //cordova.InAppBrowser.open(window.updateFile,'_system', 'location=yes');


      var fileTransfer = new FileTransfer();
      var uri = encodeURI(window.updateFile);
      var fileURL = "cdvfile://localhost/persistent/path/to/downloads/test.apk";
      fileTransfer.download(uri, fileURL, function (entry) {
        console.log("download complete: " + entry.toURL());
        cordova.plugins.fileOpener2.open(fileURL, 'application/vnd.android.package-archive');
      }, function (error) {
        $f7.dialog.alert("Install failed... internet connection or please allow app permissions in the setting");
        console.log("Download error code:" + error.code);
      });
    } else window.open(window.updateFile);
  };

  var checkSystem = function checkSystem() {
    //FIRESTORE
    var docRef = db.collection("systemv2").doc(window.service);
    docRef.get().then(function (doc) {
      if (doc.exists) {
        console.log("Document data:", doc.data());
        window.updateFile = "https://storage.googleapis.com/granddragon.appspot.com/gd-" + window.service + "-" + doc.data().version + ".apk";
        window.updateMandatory = doc.data().mandatory;
        window.updateInfo = doc.data().info;
        version = doc.data().version;

        if (window.version != version) {
          $(".button-update").show();
        } else {
          $(".button-update").hide();
        }

        if (window.updateMandatory == "yes") {
          if (window.version != version) {
            if (window.updatepopup == false) {
              window.updatepopup = true;
              $f7.dialog.confirm('Please update to Version ' + version + "<br/><br/><B>UPDATE INFO</B><BR/>" + window.updateInfo, function () {
                window.updatepopup = false;
                updateSystem();
              });
            }
          }
        } else {
          // Create toast
          var toastTop = $f7.toast.create({
            text: '<b>New Update Available: Version ' + version + "</b>",
            //<br/><span style='font-size:12px'>" + window.updateInfo + "</span>",
            position: 'top',
            closeTimeout: 2000
          });

          if (window.version != version) {
            // Open it
            if (window.service != "kiosk" && window.service != "web") toastTop.open();
          }
        }

        $update();
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    }).catch(function (error) {
      console.log("Error getting document:", error);
    });
  };

  $on('pageInit', function () {
    if (window.service != "cashier") {
      $(".block-counterfeit").hide();
    }

    for (var i = 0; i < paperSize.length; i++) {
      checked = "";
      if (localStorage.getItem("paperSize") == i) checked = "checked";
      paperlist += "\n      <li>\n        <label class=\"item-radio item-radio-icon-end item-content\">\n          <input type=\"radio\" name=\"paperSize\" class=\"paperSize\" value=\"" + i + "\" " + checked + " />\n          <i class=\"icon icon-radio\"></i>\n          <div class=\"item-inner\">\n            <div class=\"item-title\">" + paperSize[i] + " mm</div>\n          </div>\n        </label>\n      </li>\n      ";
      console.log("SERVICE" + window.service);

      if (window.service == "agent") {
        break;
      }
    }

    if (localStorage.getItem("lang") == "" || localStorage.getItem("lang") == undefined || localStorage.getItem("lang") == null) localStorage.setItem("lang", "tl");
    document.getElementById(localStorage.getItem("lang")).checked = true; // LANGUAGE CONTROLLER BEGIN

    $(".en").hide();
    $(".cn").hide();
    $(".tl").hide();
    $("." + localStorage.getItem("lang")).show();
    window.lang = localStorage.getItem("lang"); // LANGUAGE CONTROLLER END

    window.updatepopup = false;
    if (window.service != "kiosk") $(".back-button").hide();
    setTimeout(function () {
      checkSystem();
    }, 1000);
    setInterval(function () {
      if (window.updatepopup == false) checkSystem();
    }, 60000);
    setInterval(function () {
      user = localStorage.getItem("username");
    }, 1000);
    setInterval(function () {
      // LANGUAGE CONTROLLER BEGIN
      $(".en").hide();
      $(".cn").hide();
      $(".tl").hide();
      $("." + window.lang).show(); // LANGUAGE CONTROLLER END
    }, 100);
    uuid = window.uuid;
    $update();

    if (!window.DatecsPrinter) {
      if ($f7.device.cordova) alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
    } else {
      window.DatecsPrinter.listBluetoothDevices(function (devices) {
        // Check if printer has been set or not
        if (localStorage.getItem("printer") == "" || localStorage.getItem("printer") == undefined || localStorage.getItem("printer") == null) localStorage.setItem("printer", 0);
        if (localStorage.getItem("printercounterfeit") == "" || localStorage.getItem("printercounterfeit") == undefined || localStorage.getItem("printercounterfeit") == null) localStorage.setItem("printercounterfeit", 0); //List down the printer for printing

        for (var i = 0; i < devices.length; i++) {
          checked = "";
          checkedcountereit = "";
          if (localStorage.getItem("printer") == i) checked = "checked";
          if (localStorage.getItem("printercounterfeit") == i) checkedcountereit = "checked";
          bluetoothlist += "\n            <li>\n              <label class=\"item-radio item-radio-icon-end item-content\">\n                <input type=\"radio\" name=\"printer\" class=\"printer\" id=\"" + devices[i].name + "\" value=\"" + i + "\" " + checked + " />\n                <i class=\"icon icon-radio\"></i>\n                <div class=\"item-inner\">\n                  <div class=\"item-title\">" + devices[i].name + "</div>\n                </div>\n              </label>\n            </li>\n            ";
          bluetoothlistcounterfeit += "\n            <li>\n              <label class=\"item-radio item-radio-icon-end item-content\">\n                <input type=\"radio\" name=\"printercounterfeit\" class=\"printercounterfeit\" id=\"" + devices[i].name + "\" value=\"" + i + "\" " + checkedcountereit + " />\n                <i class=\"icon icon-radio\"></i>\n                <div class=\"item-inner\">\n                  <div class=\"item-title\">" + devices[i].name + "</div>\n                </div>\n              </label>\n            </li>\n            ";
        }

        $update();
        $(document).on('click', '.printer', function (e) {
          localStorage.setItem("printer", $('input[name="printer"]:checked').val());
          localStorage.setItem("printerName", e.srcElement.id);

          if (window.service != "cashier") {
            localStorage.setItem("printercounterfeit", $('input[name="printer"]:checked').val());
            localStorage.setItem("printerNameCounterfeit", e.srcElement.id);
          }

          console.log(e.srcElement.id);
        });
        $(document).on('click', '.printercounterfeit', function (e) {
          localStorage.setItem("printercounterfeit", $('input[name="printercounterfeit"]:checked').val());
          localStorage.setItem("printerNameCounterfeit", e.srcElement.id);
          console.log(e.srcElement.id);
        });
      }, function (error) {//alert(JSON.stringify(error));
      });
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="settings">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back back-button">
          <i class="icon icon-back"></i>
          <span class="if-not-md">
            <span class='en'>Back</span>
            <span class='cn'>返回</span>
            <span class='tl'>Fila</span>
          </span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Settings</span>
        <span class='cn'>设置</span>
        <span class='tl'>Konfigurasaun</span>
      </div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">
      <span class='en'>Select printer</span>
      <span class='cn'>选择打印机</span>
      <span class='tl'>Hili Printer</span>
    </div>

    <div class="list inset">
      <ul innerHTML=${bluetoothlist}>
      </ul>
    </div>

    <div class="block-title block-counterfeit">
      <span class='en'>Select counterfeit printer</span>
      <span class='cn'>选择仿冒印刷品</span>
      <span class='tl'>Hili falsu Printer</span>
    </div>

    <div class="list inset block-counterfeit">
      <ul innerHTML=${bluetoothlistcounterfeit}>
      </ul>
    </div>

    <div class="block-title">
      <span class='en'>Select paper</span>
      <span class='cn'>选择纸张</span>
      <span class='tl'>Hili Papel</span>
    </div>

    <div class="list inset">
      <ul innerHTML=${paperlist}>
      </ul>
    </div>  

    <div class="block-title">
      <span class='en'>Select Language</span>
      <span class='cn'>选择语言</span>
      <span class='tl'>Hili Lingua</span>
    </div>

    <div class="list inset">
      <ul>
        <li>
          <label class="item-radio item-radio-icon-end item-content">
            <input type="radio" id="en" name="lang" class="lang" value="en"/>
            <i class="icon icon-radio"></i>
            <div class="item-inner">
              <div class="item-title">English</div>
            </div>
          </label>
        </li>
        <li>
          <label class="item-radio item-radio-icon-end item-content">
            <input type="radio" id="tl" name="lang" class="lang" value="tl" />
            <i class="icon icon-radio"></i>
            <div class="item-inner">
              <div class="item-title">Tetun</div>
            </div>
          </label>
        </li>
        <li>
          <label class="item-radio item-radio-icon-end item-content">
            <input type="radio" id="cn" name="lang" class="lang" value="cn" />
            <i class="icon icon-radio"></i>
            <div class="item-inner">
              <div class="item-title">中文</div>
            </div>
          </label>
        </li>
      </ul>
    </div>  


    <div class="block-title">
      <span class='en'>System Information</span>
      <span class='cn'>系统信息</span>
      <span class='tl'>Sistema informasau</span>
    </div>

    <div class="card data-table">
      <table>
        <thead>
          <tr>
            <th class="label-cell">
              <span class='en'>Item</span>
              <span class='cn'>物品</span>
              <span class='tl'>Buat ruma</span>
            </th>
            <th class="numeric-cell">
              <span class='en'>Description</span>
              <span class='cn'>描述</span>
              <span class='tl'>Diskripsaun</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="label-cell">
              <span class='en'>User</span>
              <span class='cn'>用户</span>
              <span class='tl'>Uzuariu</span>
            </td>
            <td class="numeric-cell">${user}</td>
          </tr>
          <tr>
            <td class="label-cell">
              <span class='en'>Current Version</span>
              <span class='cn'>版本</span>
              <span class='tl'>Versaun agora dadaun</span>
            </td>
            <td class="numeric-cell">${currentVersion}</td>
          </tr>
          <tr>
            <td class="label-cell">UUID</td>
            <td class="numeric-cell">${uuid}</td>
          </tr>
        </tbody>
      </table>


    </div>

    
    <div class="block button-update">
      <button class="button button-fill" @click=${updateSystem}>
        <span class='en'>Update System</span>
        <span class='cn'>更新系统</span>
        <span class='tl'>Update sistema</span>
       ${version}</button>  
    </div>
    <div class="block">
      <button class="button button-fill" @click=${logout}>
        <span class='en'>Logout</span>
        <span class='cn'>登出</span>
        <span class='tl'>Sai</span>
      </button>  
    </div>

  </div>
</div>
`
    }
    ;
}

framework7Component.id = '6d3d81a326';
export default framework7Component;